import { ApiOptions } from '../../api-options.decorator';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseSupplyData } from './base';

/**
 * @internal
 */
export class ApiSupplyDataMasterData extends ApiBaseSupplyData {
  @ApiOptions({ maxSizeGetParams: 8188 })
  getMeteringMethods(commodity: string, country: string, params: ParamsAdapter) {
    return this.get(`/masterdata/metering_method/${commodity}/${country}`, params);
  }
}
